<template>
  <b-row>
    <b-col lg="12" class="mb-3 d-flex justify-content-end" v-if="createAble">
      <b-button variant="outline-primary" size="sm" @click="addData"
        >Add Data Internal Manpower</b-button
      >
    </b-col>
    <b-col lg="12">
      <table class="w-100">
        <thead>
          <th>Fullname</th>
          <th>Job Title</th>
          <th>Email Manpower</th>
          <th>Phone Manpower</th>
          <th v-if="createAble"></th>
        </thead>
        <tbody>
          <tr class="bg-white" v-for="(item, index) in data" :key="index">
            <td>
              <template v-if="item.isEdit">
                <b-input
                  v-model="item.internal_name"
                  class="rounded-sm"
                ></b-input>
              </template>
              <template v-else>
                {{ item?.internal_name ?? '-' }}
              </template>
            </td>
            <td>
              <template v-if="item.isEdit">
                <b-form-select
                  plain
                  v-model="item.internal_position_id"
                  :options="optionsJabatan"
                  class="rounded-sm"
                ></b-form-select>
              </template>
              <template v-else>
                {{
                  optionsJabatan.find(
                    (el) => item?.internal_position_id == el.value
                  )?.text ?? '-'
                }}
              </template>
            </td>
            <td>
              <template v-if="item.isEdit">
                <b-input
                  v-model="item.internal_email"
                  class="rounded-sm"
                ></b-input>
              </template>
              <template v-else>
                {{ item?.internal_email ?? '-' }}
              </template>
            </td>
            <td>
              <template v-if="item.isEdit">
                <b-input
                  v-model="item.internal_phone"
                  type="number"
                  class="rounded-sm"
                ></b-input>
              </template>
              <template v-else>
                {{ item?.internal_phone ?? '-' }}
              </template>
            </td>
            <td v-if="createAble">
              <div class="d-flex">
                <b-button
                  class="mr-2"
                  @click="$emit('onDelete', index)"
                  variant="outline-primary"
                  size="sm"
                >
                  <i class="fa fa-trash m-0"></i>
                </b-button>
                <b-button
                  v-if="!item.isEdit"
                  @click="item.isEdit = true"
                  variant="outline-success"
                  size="sm"
                >
                  <i class="fa fa-edit m-0"></i>
                </b-button>
                <b-button
                  v-else
                  @click="item.isEdit = false"
                  variant="outline-primary"
                  size="sm"
                >
                  <i class="fa fa-save m-0"></i>
                </b-button>
              </div>
            </td>
          </tr>
          <tr
            class="bg-white"
            v-for="(item, index) in manPowers"
            :key="`new-data-${index}`"
          >
            <td>
              <b-input
                v-model="item.internal_name"
                class="rounded-sm"
              ></b-input>
            </td>
            <td>
              <b-form-select
                plain
                v-model="item.internal_position_id"
                :options="optionsJabatan"
                class="rounded-sm"
              >
              </b-form-select>
            </td>
            <td>
              <b-input
                v-model="item.internal_email"
                class="rounded-sm"
              ></b-input>
            </td>
            <td>
              <b-input
                v-model="item.internal_phone"
                type="number"
                class="rounded-sm"
              ></b-input>
            </td>
            <td class="" style="min-width: 100px;">
              <div class="flex">
                <b-button
                  class="mr-2"
                  @click="manPowers = []"
                  variant="outline-primary"
                  size="sm"
                >
                  <i class="fa fa-trash m-0"></i>
                </b-button>
                <b-button
                  variant="outline-primary"
                  size="sm"
                  @click="$emit('onAdd', item), (manPowers = [])"
                >
                  <i class="fa fa-save m-0"></i>
                </b-button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        v-if="!data?.length && !manPowers.length"
        class="p-3 d-flex justify-content-center"
      >
        <img
          :src="require('@/public/img/not-found-image.png')"
          alt="not-found-image"
          width="160"
          height="140"
        />
      </div>
    </b-col>
  </b-row>
</template>
<script>
import { optionsJabatan } from '@/src/core/mock/data/optionsData'

export default {
  data() {
    return {
      manPowers: [],
      optionsJabatan: optionsJabatan,
    }
  },
  props: {
    item_id: null,
    data: {
      type: Array,
      default: () => [],
    },
    createAble: Boolean,
  },
  methods: {
    addData() {
      this.manPowers = []
      this.manPowers.push({
        repair_form_id: this.item_id,
        user_id: JSON.parse(localStorage.getItem('profile')).id,
        internal_name: '',
        entity_type: 'internal',
        internal_position_id: '',
        subkon_name: '',
        subkon_pic: '',
        subkon_pic_phone: '',
        subkon_pic_email: '',
        subkon_price_offering: '',
        subkon_price_nego: '',
        subkon_price_deal: '',
        subkon_notes: '',
        subkon_file: [],
        isEdit: false,
      })
    },
  },
}
</script>

<style scoped>
table th {
  padding: 8px;
  width: 25%;
}

table td {
  padding: 8px;
  width: 25%;
  border-bottom: 1px solid gray !important;
}
</style>
